module.exports = __webpack_public_path__ + "static/3-a7622f60c56ddd5301549a786b54e6e6.woff";